enum PurchaseType {
  CASH = 'CASH',
  FINANCE = 'FINANCE',
  LEASE = 'LEASE',
  LINE_OF_CREDIT = 'LINE OF CREDIT',
}

export default PurchaseType;
